import React from 'react';
import { Container, Typography, Box, Divider } from '@mui/material';
import Header from '../components/layout/Header';

const MentionsLegales = () => {
  return (
    <>
    <Header />
    <Container maxWidth="md" sx={{ pt: 6 }}>
      <Typography variant="h4" gutterBottom fontWeight="bold">
        Mentions légales
      </Typography>

      <Divider sx={{ my: 3 }} />

      <Box sx={{ mb: 4 }}>
        <Typography variant="h6">Éditeur du site</Typography>
        <Typography>
          Ce site est édité par <strong>MyGospelPass</strong>.
          <br />
          Pour toute question, vous pouvez nous contacter à :{" "}
          <a href="mailto:contact@mygospelpass.com">contact@mygospelpass.com</a>
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h6">Hébergement</Typography>
        <Typography>
          Le site est hébergé par notre prestataire sur un serveur sécurisé (VPS).<br />
          Les données sont stockées en France ou dans l'Union Européenne.
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h6">Utilisation des données personnelles</Typography>
        <Typography>
          Les informations collectées via le système de billetterie sont utilisées uniquement pour :
          <ul>
            <li>La gestion des réservations et billets</li>
            <li>La communication liée à votre inscription</li>
          </ul>
          <strong>Nous ne revendons ni ne partageons vos données personnelles</strong> à des tiers.
          <br />
          Les données sont conservées uniquement le temps nécessaire à la gestion de votre réservation.
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h6">Cookies</Typography>
        <Typography>
          Ce site utilise uniquement les cookies nécessaires à son bon fonctionnement (pas de publicité, pas de tracking).
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h6">Droits des utilisateurs</Typography>
        <Typography>
          Conformément au RGPD, vous disposez d’un droit d’accès, de rectification, de suppression et de portabilité de vos données.
          <br />
          Pour toute demande, contactez-nous à :{" "}
          <a href="mailto:contact@mygospelpass.com">contact@mygospelpass.com</a>
        </Typography>
      </Box>

      <Divider sx={{ mt: 4 }} />
    </Container>
    </>
  );
};

export default MentionsLegales;
